import React, { useState, createContext } from "react";

import FiltersWrapper from "../filters/FiltersWrapper";
import Header from "../../../Layouts/Components/Header";
import PrimaryButton from "../PrimaryButton";
import CustomIcon from "../CustomIcon";
import exportIcon from "../../../assets/icons/export.svg";
import { Popover } from "@mui/material";
import ExportDialog from "../ExportDialog";
import { getInitialFilters, initialFilters } from "../../../utils/filters";
import { useSearchParams } from "react-router-dom";

export const SwiftContext = createContext(null);

const Swift = ({ children, view }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(getInitialFilters(view));

  const renderAllFilters = searchParams.get("allFilters") !== null;

  const [popoverEl, setPopoverEl] = useState(null);
  const [exportBtnDisabled, setExportBtnDisabled] = useState(true);
  const [openExportDialog, setOpenExportDialog] = useState(false);

  const openPopover = Boolean(popoverEl);
  const popoverId = openPopover ? "action-popover" : undefined;

  const handleOpenPopover = (e) => {
    e.preventDefault();
    setPopoverEl(e.currentTarget);
  };

  const handleClosePopover = (e) => {
    e.preventDefault();
    setPopoverEl(null);
  };

  const handleFiltersChange = (updatedFilters) => {
    setFilters({ ...filters, ...updatedFilters });
  };

  const handleToggleRenderAllFilters = () => {
    const value = !renderAllFilters;

    if (value) {
      setSearchParams({ allFilters: true });
    } else {
      searchParams.delete("allFilters");
      setSearchParams(searchParams);
    }
  };

  const handleResetFilters = () => {
    setFilters({
      ...initialFilters,
      dateTimeFrom: filters.dateTimeFrom,
      dateTimeTo: filters.dateTimeTo,
    });
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { filters });
    }
    return child;
  });

  return (
    <>
      <SwiftContext.Provider
        value={{
          exportBtnDisabled,
          setExportBtnDisabled,
          openExportDialog,
          setOpenExportDialog,
        }}
      >
        {!renderAllFilters && (
          <Header
            headLine={view === "day" ? "Swift Day Messages" : "Swift Messages"}
          >
            {view !== "day" && (
              <PrimaryButton
                startIcon={<CustomIcon svgIcon={exportIcon} fontSize="small" />}
                onClick={() => setOpenExportDialog(true)}
                disabled={exportBtnDisabled}
              >
                Export
              </PrimaryButton>
            )}
          </Header>
        )}

        <FiltersWrapper
          headLine={
            view === "day" ? "Swift Day Filters" : "Swift Messages Filters"
          }
          filters={{ ...filters }}
          handleFiltersChange={handleFiltersChange}
          renderAllFilters={renderAllFilters}
          handleToggleRenderAllFilters={handleToggleRenderAllFilters}
          handleResetFilters={handleResetFilters}
          isDayView={view === "day"}
        />
        {!renderAllFilters && childrenWithProps}
      </SwiftContext.Provider>
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={popoverEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <ExportDialog />
      </Popover>
    </>
  );
};

export default Swift;
